import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Card({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path d="M5.33333 16H11.3333V14.6667H5.33333V16Z" fill={iconColor} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66667 4.66667C2.29848 4.66667 2 4.96515 2 5.33334V8.00001C2 8.3682 2.29848 8.66667 2.66667 8.66667H20.6667V11.3333H2.66667C2.29848 11.3333 2 11.6318 2 12V18.6667C2 19.0349 2.29848 19.3333 2.66667 19.3333H21.3333C21.7015 19.3333 22 19.0349 22 18.6667V5.33334C22 4.96515 21.7015 4.66667 21.3333 4.66667H2.66667ZM20.6667 6.00001V7.33334H3.33333V6.00001H20.6667ZM3.33333 12.6667H20.6667V18H3.33333V12.6667Z"
        fill={iconColor}
      />
    </Svg>
  );
}
